export default __webpack_public_path__ + "static/media/human_error.84873728.png";